
import React, { useState, useEffect, useRef } from "react";
import "../assets/css/home.css";
import "../assets/css/popup.css";
import axios from "axios";
import sublogo from '../assets/images/main_logo.png';

import { toast, ToastContainer } from "react-toastify";
import configModule from '../../config.js';
import { useLocation, useNavigate } from "react-router-dom";
import SvgContent from "../components/Svgcontent.jsx";
import Footer from "./footer.jsx";

import banner1 from "../assets/images/banner1.png";
import banner2 from "../assets/images/banner2.png";
import banner3 from "../assets/images/banner3.png";
import banner4 from "../assets/images/banner4.png";

import pti from "../assets/images/pti.png";
import indto from "../assets/images/indto.png";
import busto from "../assets/images/busto.png";
import bloom from "../assets/images/bloom.png";
import manorama from "../assets/images/manorama.png";
import bw from "../assets/images/bw.png";
import dsij from "../assets/images/dsij.png";
import hindia from "../assets/images/hindia.png";
import ibtn from "../assets/images/ibtn.png";
import dlearn from "../assets/images/dlearn.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const Home = () => {
  const [index, setIndex] = useState(0);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [courses, setCourses] = useState([]);
  const [courseDetails, setCourseDetails] = useState([]);
  const [reviewDetails, setReviewDetails] = useState([]);
  const [topCollegeDetails, setTopCollegeDetails] = useState([]);
  const [pickYourInt, setPickYourInt] = useState([]);
  const [search, setSearch] = useState("");
  const config = configModule.config();
  const [showAll, setShowAll] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [hrFade, setHrFade] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const ref = useRef(null);

  const [isSubmit, setIsSubmit] = useState(false);
  const contactRef = useRef(null);
  const homeRef = useRef(null);
  const courseRef = useRef(null);

  const dropdownRef = useRef(null);

  const [appNowFormData, setAppNowFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course_type: "UG",
    location: "",
    message: "",
  });

  const Counter = ({ end }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      let start = 0;
      const duration = 500;
      const increment = end / (duration / 20);

      const timer = setInterval(() => {
        start += increment;

        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 20);

      return () => clearInterval(timer);
    }, [end]);

    return <>{count.toLocaleString()}</>;
  };

  const stats = [
    { number: 633, label: "universities" },
    { number: 7600, label: "colleges" },
    { number: 1300, label: "courses" },
    { number: 152, label: "exams" },
  ];


  const slugify = (name) =>
    name
      ?.split(" ")
      .map(word => {
        if (word.toUpperCase() === word) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join("-");

  const slides = [
    {
      bg: banner1,
      content: (
        <>
          <h1 className="glow-text">
            Your Dream College
            <br /> <span style={{ color: "#00B5B5", fontStyle: "normal" }}>Starts Here.</span>
          </h1>

          <p className="headpara-st">
            Compare colleges, discover courses, and make smarter
            career decisions.
          </p>
        </>
      ),
    },

    {
      bg: banner2,
      content: (
        <>
          <h1 className="glow-text">
            Explore Colleges, Compare Courses, <br /> <span style={{ color: "#00B5B5", fontStyle: "normal" }}>Choose Better.</span>
          </h1>

          <p className="headpara-st">
            Everything you need to plan your higher education journey.
          </p>
        </>
      ),
    },

    {
      bg: banner3,
      content: (
        <>
          <h1 className="glow-text">
            India’s Smart College <br /><span style={{ color: "#00B5B5", fontStyle: "normal" }}>Discovery Platform</span>
          </h1>

          <p className="headpara-st">
            Explore admissions, rankings, fees, placements, and more.
          </p>
        </>
      ),
    },

    {
      bg: banner4,
      content: (
        <>
          <h1 className="glow-text">
            Start Your Higher Education <br /><span style={{ color: "#00B5B5", fontStyle: "normal" }}>Journey Today</span>
          </h1>

          <p className="headpara-st">
            Find colleges, explore courses, and unlock new opportunities.
          </p>
        </>
      ),
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setHrFade(false);

      const timeout = setTimeout(() => {
        setIndex((prev) => (prev + 1) % slides?.length);
        setHrFade(true);
      }, 500);

      return () => clearTimeout(timeout);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides?.length]);

  const handleSearch = async (value) => {
    if (!value) {
      setColleges([]);
      setCourses([]);
      return;
    }

    try {
      const res = await axios.get(`${config.apiBaseUrl}/colleges-search?search=${value}`, {
        headers: {
          "x-api-key": config?.apichKey
        }
      }
      );

      setColleges(res.data?.college);
      setCourses(res.data?.courses);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCourseDetails = async () => {
    try {
      const res = await axios.get(`${config.apiBaseUrl}/courses-details`, {
        headers: {
          "x-api-key": config?.apichKey
        }
      }
      );

      setCourseDetails(res?.data?.courses);
      setReviewDetails(res?.data?.topReviews);
      setTopCollegeDetails(res?.data?.topColleges);
      setPickYourInt(res?.data?.pickyourint);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getCourseDetails();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const section = document.getElementById("contact");
      const homeSection = document.getElementById("home");
      const courseSection = document.getElementById("course");

      if (location.state?.scrollTo === "contact" && section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else if (
        location.state?.scrollTo === "home" &&
        homeSection
      ) {
        homeSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else if (
        location.state?.scrollTo === "course" &&
        courseSection
      ) {
        courseSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [location]);

  const brands = [
    { name: "Manorama Online", logo: pti, url: "https://www.manoramaonline.com/education/education-news/campus-hunt-laptop.html" },
    { name: "India Today", logo: indto, url: "https://www.indiatoday.in/education-today/news/story/first-free-education-portal-319868-2016-04-25" },
    { name: "Business Today", logo: busto, url: "https://www.businesstoday.in/prnewswire/?rkey=20180312enIN201803123911_indiapublic&filter=2418" },
    { name: "Bloomberg", logo: bloom, url: "https://campushunt.in/images/bloomberg.gif" },
    { name: "Press Trust of India", logo: manorama, url: "http://archive.ptinews.com/pressrelease/28656_press-subCampusHunt-in-Amongst-the-Top-10-Education-Portals-and-Top-100-Startups-in-India" },
    { name: "Businessworld", logo: bw, url: "http://www.businessworld.in/article/CampusHunt-in-Amongst-the-Top-10-Education-Portals-and-Top-100/12-03-2018-143125/" },
    { name: "Dalal Street Investment Journal", logo: dsij, url: "https://www.dsij.in/login?returnurl=%2fnewswiredetails%2ffilename%2f201701022335pr_news_euro_nd__enin201701027585_indiapublic" },
    { name: "The Hans India", logo: hindia, url: "https://www.thehansindia.com/" },
    { name: "IBTN", logo: ibtn, url: "https://ibtn9.com/pr-newswire/?rkey=20180312enIN201803123911_indiapublic&filter=12202" },
    { name: "Digital Learning", logo: dlearn, url: "https://digitallearning.eletsonline.com/2016/04/campushunt-in-india-gets-its-first-free-highly-interactive-education-portal/" }
  ];

  function StatBox({ number, label, delay, className = "" }) {
    const [count, setCount] = useState(0);

    useEffect(() => {
      let start = 0;
      const end = number;
      const duration = 1500;
      const increment = Math.ceil(end / (duration / 16));

      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, 16);

      return () => clearInterval(timer);
    }, [number]);

    return (
      <div className={`stat-box ${className}`}
        style={{ animationDelay: `${delay}s` }}>
        <h2>{count}</h2>
        <p>{label}</p>
      </div>
    );
  }

  useEffect(() => {
    const elements = document.querySelectorAll(".section, .form-container, .slide-left, .slide-right, .fade-up, .dep_category_card , .brand-wrapper-st, .cu_how_section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.4 }
    );

    elements.forEach((el) => observer.observe(el));

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  const visibleItems = showAll
    ? pickYourInt
    : (Array.isArray(pickYourInt) ? pickYourInt.slice(0, 10) : []);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setStartIndex((prev) => {
          const next = prev + 3;

          return next >= reviewDetails?.length ? 0 : next;
        });

        setFade(true);
      }, 400);
    }, 3000);

    return () => clearInterval(interval);
  }, [reviewDetails?.length]);

  // show only 3 items
  const visibleSWItems = reviewDetails?.slice(startIndex, startIndex + 3) || [];

  const appNowHandleChange = (e) => {
    setAppNowFormData({
      ...appNowFormData,
      [e.target.name]: e.target.value,
    });
  };

  const appNowHandleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmit(true);

    try {
      const response = await axios.post(
        `${config.apiBaseUrl}/home-appnow`,
        appNowFormData,
        {
          headers: {
            "x-api-key": config.apichKey,
          },
        }
      );

      if (response.data.success) {
        toast.success(response.data.message);
        setOpen(false);
        setIsSubmit(false);


        setAppNowFormData({
          name: "",
          email: "",
          phone: "",
          course_type: "UG",
          location: "",
          message: "",
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Submission failed"
      );
    }
  };

  const avatarColors = [
    "#F44336",
    "#E91E63",
    "#9C27B0",
    "#673AB7",
    "#3F51B5",
    "#2196F3",
    "#009688",
    "#4CAF50",
    "#FF9800",
    "#795548",
  ];

  const getAvatarColor = (name = "") => {
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      avatarColors.length;
    return avatarColors[index];
  };

  return (
    <div className="main-container" >
      <ToastContainer />
      <div className="fade-carousel-wrapper">
        <div className="maincontent-divst">
          <div className="maincont-body-st">
            <div className="herodiv-st" id="home" ref={homeRef}>
              <div className="inrherodiv-st position-relative hrcontent-box">
                <div className={`herocontentslide-st ${hrFade ? "hrfade-in" : "hrfade-out"}`} >
                  <div className="ch-hero-badge">
                    <SvgContent svg_name="sparkles" width={15} height={15} /> India's #1 College Discovery Platform</div>

                  {slides[index].content}
                </div>
                <div className="ch-search-bar" ref={dropdownRef}>
                  <i className="ti ti-search" aria-hidden="true"></i>
                  <input type="text" value={search}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearch(value);
                      setShowDropdown(true);
                      handleSearch(value);
                    }} placeholder="Search courses, colleges..." />
                  <button className="ch-search-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setColleges([]);
                      setCourses([]);

                      navigate(`/college_listing`, {
                        state: search,
                      });
                    }}
                  >Search</button>

                  {showDropdown && (
                    <div className="search-dropdown">
                      <div className="subcarddd-st">
                        <h5 className="coldd-st">Colleges</h5>
                        {colleges?.length > 0 ? (colleges?.map((college) => (
                          <div
                            key={college.id}
                            className="search-item"
                            onClick={() => {
                              setSearch(college.name);
                              setColleges([]);
                              setCourses([]);

                              navigate(`/${college.id}/${slugify(college.name)}`, {
                                state: college,
                              });
                            }}
                          >
                            <i className="ti ti-school"></i>
                            <span>{college.name}</span>
                          </div>
                        ))) : (
                          <p className="noitemst">-- No data found --</p>
                        )}
                      </div>
                      <div className="subcarddd-st">
                        <h5 className="coldd-st">Courses</h5>
                        {courses?.length > 0 ? (courses?.map((course) => (
                          <div
                            key={course.id}
                            className="search-item"
                            onClick={() => {
                              setSearch(course.course);
                              setColleges([]);
                              setCourses([]);

                              navigate(`/college_listing?course_id=${course.id}`, {
                                state: course,
                              });
                            }}
                          >
                            <i className="ti ti-school"></i>
                            <span>{course.course}</span>
                          </div>
                        ))) : (
                          <p className="noitemst">-- No data found --</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="carousel-box align-items-end justify-content-center">
                  <img
                    src={slides[index].bg}
                    className={`imagebanner-st ${hrFade ? "hrfade-in" : "hrfade-out"}`}
                    alt="banner"
                  />
                </div>
              </div>


              <div className="inrcountherodiv-st">
                {stats.map((item, index) => (
                  <React.Fragment key={index}>
                    <div className="ltrcodefordb-st">
                      <h2 className="playfair-font mb-0 fw-bold">
                        <Counter end={item.number} />
                      </h2>
                      <p className="nameboard-st mb-0">{item.label}</p>
                    </div>

                    {index !== stats.length - 1 && (
                      <span className={`codefordb-st ${index === 1 ? 'mbcodefordb-st' : ''}`}>
                        |
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </div>


            </div>
            <div className="course_container-main" style={{ background: "#E8F8F8" }}>
              <div className="course_container " id="course" ref={courseRef} >
                <h1 className="tc-section-label w-100 text-align-cn ">Trending courses</h1>

                <div className="course_track">
                  {courseDetails?.map((c) => (
                    <div key={c.id} className="wordtrend-st tc-tagname">
                      {c.course}
                    </div>
                  ))}
                </div>

                <h1 className="heading-coursest ch-section-heading text-align-cn section">Pick Your Interest</h1>
                <div className="ch-section-sub">Browse by stream and find the right college for you</div>
                <div className="display-flex justify-content-center align-items-center dep_scene fade-up">
                  {visibleItems?.map((item, index) => (
                    <div key={index} className="pyi-interest-card" style={{
                      "--card-top-color": item?.icon_color,
                      animationDelay: `${index * 100}ms`
                    }}
                      onClick={() =>
                        navigate(
                          `/${item.id}/best-colleges-under-${item.category.toLowerCase()}`,
                          { state: item }
                        )
                      }>
                      <div
                        className="pyiicondiv-st "
                        style={{ background: item?.icon_bgcolor }}
                      >
                        <SvgContent
                          svg_name={item.icon_class_name}
                          height="24"
                          width="24"
                          stroke={item.icon_color}
                        />
                      </div>

                      <p className="pyiname-st">{item.category}</p>
                      <p
                        className="pyinamecl-st"
                      >
                        {item.no_of_colleges} Colleges
                      </p>
                    </div>
                  ))}
                </div>

                {pickYourInt?.length > 10 && (
                  <button
                    onClick={() => setShowAll(!showAll)}
                    className="pyi-view-all"
                  >
                    {showAll ? (
                      <>
                        <SvgContent svg_name="minz_icon" width="32" height="32" />
                        Show Less
                      </>

                    ) : (
                      <>
                        <SvgContent svg_name="grid_icon" width="32" height="32" />
                        View All Streams
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>

            <div className="college-st">
              <div className="w-100">
                <h1 className="help-section-label w-100 text-align-cn ">How It Works</h1>
                <h1 className="heading-coursest ch-section-heading text-align-cn section">HOW WE HELP YOU GET ADMITTED ?</h1>
                <div className="ch-section-sub fade-up">A guided process designed to simplify your college admission journey.</div>

                <div className="cu_how_section">
                  <div className="cu_container">
                    <div className="ch-steps">
                      <div className="ch-step slide-left position-relative">
                        <div>
                          <span className="ch-step-num">01</span>
                          <div className="ch-step-icon">
                            <SvgContent svg_name="pad_icon" />
                          </div>
                        </div>
                        <div>
                          <h3>Tell Us Your Preferences</h3>
                          <p>Share your course interest, location preference, and academic details with us.</p>
                        </div>
                      </div>
                      <div className="ch-step slide-right position-relative">
                        <div>
                          <span className="ch-step-num">02</span>
                          <div className="ch-step-icon">
                            <SvgContent svg_name="assist_icon" />
                          </div>
                        </div>
                        <div>
                          <h3>Get Curated College Options</h3>
                          <p>Share your course interest, location preference, and academic details with us.</p>
                        </div>
                      </div>
                      <div className="ch-step slide-left position-relative">
                        <div>
                          <span className="ch-step-num">03</span>
                          <div className="ch-step-icon">
                            <SvgContent svg_name="tell_icon" />
                          </div>
                        </div>
                        <div>
                          <h3>We Assist Till Admission</h3>
                          <p>Our expert advisors guide you through applications and final admission.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="course_container-main" style={{ padding: "0px", background: "white" }} >
              <div className="w-100 popularpicks-st">
                <h1 className="tc-section-label poppicks-st w-100 text-align-cn " style={{ padding: "0px 42px" }}>Popular Picks</h1>
                <h1 className="heading-coursest poppicks-st ch-section-heading text-align-cn section mb-4" style={{ padding: "0px 42px" }}>Most Popular Colleges</h1>

                {/* <div className="carousel-container">
                  <div className="carousel-track">
                    {topCollegeDetails?.map((college, i) => (
                      <div className="college-card-st" key={i}>
                        <div className="herocaro" key={i} >
                          <img className="herocaro-profile-img" src={college.college_primary_image} alt="herocaro" />
                          <div className="herocaro-profile-botm" >
                            <div className="ch-college-name">{college.name}</div>
                          </div>

                          <div className="herocaro-logo">
                            <img src={college.college_logo} alt="logo" />
                          </div>

                          <button className="herocarorat-btn" >{college.college_ranking}</button>
                          <button className="herocaro-btn" onClick={() => setOpen(true)} >Apply Now</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}

                <Swiper
                  modules={[Autoplay]}
                  loop={true}
                  spaceBetween={16}
                  className="mb-4"
                  style={{ padding: "0px 18px" }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      spaceBetween: 12,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 16,
                    },
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                >
                  {topCollegeDetails?.map((college, i) => (
                    <SwiperSlide key={i}>
                      <div
                        className="herocaro"
                        onClick={() => {
                          navigate(`/${college.id}/${slugify(college.name)}`, { state: college });
                        }}
                      >
                        <img className="herocaro-profile-img" src={college.college_primary_image} alt={college.name} />
                        <div className="herocaro-profile-botm">
                          <div className="ch-college-name">{college.name}</div>
                        </div>
                        <div className="herocaro-logo">
                          <img src={college.college_logo} alt="logo" />
                        </div>
                        <button className="herocarorat-btn">{college.college_ranking}</button>
                        <button className="herocaro-btn" onClick={() => setOpen(true)}>
                          Apply Now
                        </button>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="w-100 scholwords-st" >
                <h1 className="tc-section-label w-100 text-align-cn ">Scholar's Voice</h1>
                <h1 className="heading-coursest ch-section-heading text-align-cn section" >Scholar's "Words" Strengthen Us</h1>

                <div className={`creationsBlocUl ${fade ? "fade-in" : "fade-out"}`}>
                  {visibleSWItems?.map((item, index) => (
                    <figure
                      className="creaBlock creaBlockPrez d-center flex-column scholarsword-st"
                      key={index}
                    >
                      <div className="ch-stars">★ ★ ★ ★ ★</div>

                      <h2
                        className="ch-testi-quote"
                      >
                        "{item?.quotes}"
                      </h2>


                      <div className="ch-testi-author">
                        {item?.img ? (
                          <img
                            src={item.img}
                            className="ch-testi-avatar"
                            alt={item?.quotes_by}
                            title={item?.quotes_by}
                          />
                        ) : (
                          <div
                            className="ch-testi-avatar avatar-fallback"
                            style={{
                              backgroundColor: getAvatarColor(item?.quotes_by),
                            }}
                            title={item?.quotes_by}
                          >
                            {item?.quotes_by?.charAt(0)?.toUpperCase() || "?"}
                          </div>
                        )}

                        <div className="">
                          <p className="ch-testi-name">{item.quotes_by}</p>
                        </div>
                      </div>
                    </figure>
                  ))}
                </div>
              </div>

              <div className="d-center paddfor-med" style={{ padding: "22px 42px 0pc 42px" }}>
                <div className="d-center flex-column medlogopad-st">
                  <img src={sublogo} alt="main_logo" className="img-mainst" style={{ maxWidth: "100%", width: "auto" }} />
                  <h4 className="mbfontsize-st" style={{ fontWeight: "500", color: "rgb(146 ,146, 146)", textAlign: "center", marginBottom: "0px" }}>In Media</h4>
                </div>

                <div className="brand-slider">
                  <div className="brand-track">
                    {[...brands, ...brands]?.map((brand, index) => (
                      <div className="brand-item" key={index} onClick={() => window.open(brand?.url, "_blank", "noopener,noreferrer")}>
                        <img src={brand.logo} alt={brand.name} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="ch-colleges" id="contact" ref={contactRef}>
                <div className="ch-cta-banner">
                  <div>
                    <h3>Ready to find your dream college?</h3>
                    <p>Start with a free 15-minute guidance session — no commitment, no fees.</p>
                  </div>
                  <button className="ch-cta-btn" onClick={() => setOpen(true)}>Start With Free Guidance →</button>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {open && (
        <div className="popup-overlay" onClick={() => setOpen(false)}>
          <div
            className="popup-content form-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="form-container section">
              <form className="inquiry-form" onSubmit={appNowHandleSubmit}>
                <div className="w-100 d-flex justify-content-between">
                  <img
                    src={sublogo}
                    alt="main_logo"
                    className="img-mainst"
                    style={{ width: "fit-content" }}
                  />

                  <button
                    type="button"
                    className="closecontact-st"
                    onClick={() => setOpen(false)}
                  >
                    ✕
                  </button>
                </div>

                <input
                  type="text"
                  name="full_name"
                  placeholder="Full Name*"
                  value={appNowFormData?.full_name || ""}
                  onChange={appNowHandleChange}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email*"
                  value={appNowFormData?.email || ""}
                  onChange={appNowHandleChange}
                  required
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone*"
                  value={appNowFormData?.phone || ""}
                  onChange={appNowHandleChange}
                  required
                />

                <select
                  name="course_type"
                  value={appNowFormData?.course_type || ""}
                  onChange={appNowHandleChange}
                >
                  <option value="UG">UG</option>
                  <option value="PG">PG</option>
                  <option value="Diploma">Diploma</option>
                </select>

                <input
                  type="text"
                  name="preferred_location"
                  placeholder="Prefer Location"
                  value={appNowFormData?.preferred_location || ""}
                  onChange={appNowHandleChange}
                />

                <textarea
                  name="message"
                  placeholder="Write your course / message..."
                  value={appNowFormData?.message || ""}
                  onChange={appNowHandleChange}
                />

                <div className="btncontainer-form">
                  <button
                    className="submitcontact-st"
                    type="submit"
                    disabled={isSubmit}
                  >
                    {isSubmit ? "Sending..." : "Send"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;